
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/automations",
      function () {
        return require("private-next-pages/features/automations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/automations"])
      });
    }
  